module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stadium-monitor-wrapper"
  }, [_c('div', {
    staticClass: "flex-row-between margin-bottom-10"
  }, [_c('h3', [_vm._v("摄像头")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddCamera
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "camera-bezel"
  }, _vm._l((_vm.cameraConfig), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "camera-item flex-column"
    }, [_c('div', {
      staticClass: "flex-row-between margin-bottom-10"
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择盒子"
      },
      on: {
        "change": _vm.handleConfigModel
      },
      model: {
        value: (item.boxId),
        callback: function($$v) {
          _vm.$set(item, "boxId", $$v)
        },
        expression: "item.boxId"
      }
    }, _vm._l((_vm.deviceList), function(device, deviceIndex) {
      return _c('el-option', {
        key: deviceIndex,
        attrs: {
          "label": device.uid,
          "value": device.uid
        }
      })
    }), 1), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteCamera(item)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-select', {
      staticClass: "margin-bottom-10",
      attrs: {
        "placeholder": "请选择场馆"
      },
      on: {
        "change": _vm.handleConfigModel
      },
      model: {
        value: (item.venueId),
        callback: function($$v) {
          _vm.$set(item, "venueId", $$v)
        },
        expression: "item.venueId"
      }
    }, _vm._l((_vm.stadiumList), function(stadium, stadiumIndex) {
      return _c('el-option', {
        key: stadiumIndex,
        attrs: {
          "label": stadium.areaName,
          "value": stadium.areaId,
          "disabled": _vm.handleCameraStadiumDisabled(stadium.areaId, index)
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "input-bezel flex-row"
    }, [_c('span', [_vm._v("单次运动结束时间: ")]), _vm._v(" "), _c('el-input-number', {
      attrs: {
        "controls": false,
        "min": 0
      },
      on: {
        "input": _vm.handleConfigModel
      },
      model: {
        value: (item.sportTimeLimit),
        callback: function($$v) {
          _vm.$set(item, "sportTimeLimit", $$v)
        },
        expression: "item.sportTimeLimit"
      }
    }), _vm._v(" "), _c('span', [_vm._v(" 分钟")])], 1), _vm._v(" "), _c('div', {
      staticClass: "tips-text"
    }, [_vm._v("超过该时间未抓拍到新的照片，则结束该次运动生成一条运动记录")]), _vm._v(" "), (item.boxId) ? _c('div', [_c('el-upload', {
      staticClass: "upload-file",
      attrs: {
        "accept": ".yaml",
        "name": "file",
        "show-file-list": false,
        "action": _vm.$util.aioIP + '/api/m/sys/config/file/v365/upload',
        "headers": {
          channelCode: _vm.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj'
        },
        "data": {
          schoolId: _vm.schoolId,
          uid: item.boxId,
          userName: _vm.$store.state.user.name
        },
        "on-success": _vm.handleSuccess,
        "on-error": _vm.handleError
      }
    }, [_c('el-button', [_vm._v("选择上传文件")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-around"
    }, [_c('span', [_vm._v(_vm._s(_vm.handleSelectedBoxInfo(item.boxId).fileName || ''))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.handleSelectedBoxInfo(item.boxId).createTime || ''))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.handleSelectedBoxInfo(item.boxId).uploader || ''))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-between"
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.clickUploadConfigRecord(item)
        }
      }
    }, [_vm._v("查看上传记录")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.clickDownload(item)
        }
      }
    }, [_vm._v("下载")])], 1)], 1) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "flex-row-between margin-top-20 margin-bottom-10"
  }, [_c('div', {
    staticClass: "flex-row gap-10"
  }, [_c('h3', [_vm._v("是否启用闸机")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.handleConfigModel
    },
    model: {
      value: (_vm.openGateMachine),
      callback: function($$v) {
        _vm.openGateMachine = $$v
      },
      expression: "openGateMachine"
    }
  })], 1), _vm._v(" "), (_vm.openGateMachine) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddBinding
    }
  }, [_vm._v("\n         添加绑定关系\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.openGateMachine) ? _c('div', {
    staticClass: "gate-bezel"
  }, _vm._l((_vm.gateMachineConfig), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gate-item flex-row gap-10"
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入闸机采集模块序列号"
      },
      on: {
        "input": _vm.handleConfigModel
      },
      model: {
        value: (item.gateMachineId),
        callback: function($$v) {
          _vm.$set(item, "gateMachineId", $$v)
        },
        expression: "item.gateMachineId"
      }
    }), _vm._v(" "), _c('span', [_vm._v("绑定")]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "请选择场馆"
      },
      on: {
        "change": _vm.handleConfigModel
      },
      model: {
        value: (item.venueId),
        callback: function($$v) {
          _vm.$set(item, "venueId", $$v)
        },
        expression: "item.venueId"
      }
    }, _vm._l((_vm.stadiumList), function(stadium, stadiumIndex) {
      return _c('el-option', {
        key: stadiumIndex,
        attrs: {
          "label": stadium.areaName,
          "value": stadium.areaId,
          "disabled": _vm.handleGateMachineStadiumDisabled(stadium.areaId, index)
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      staticClass: "direction-select",
      on: {
        "change": _vm.handleConfigModel
      },
      model: {
        value: (item.direction),
        callback: function($$v) {
          _vm.$set(item, "direction", $$v)
        },
        expression: "item.direction"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "进",
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "出",
        "value": 2
      }
    })], 1), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteGate(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50080f46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/Components/StadiumMonitor.vue
// module id = 1023
// module chunks = 0